import { inject, Injectable } from '@angular/core';

import { JobsWrapperActionsService } from '@core/offers-data';
import { StatusChangeType } from '@core/offers-types';

@Injectable({ providedIn: 'root' })
export class ArchiveJobFacade {
  private readonly jobsWrapperActionsService = inject(JobsWrapperActionsService);

  public readonly statusChangeSuccess$ = this.jobsWrapperActionsService.changeStatusSuccessAction$;

  public archive(id: number) {
    this.jobsWrapperActionsService.changeStatus(id, StatusChangeType.Archive);
  }
}
